module.exports = __webpack_public_path__ + "static/media/7.02f2fe4a.jpg";